import React, { useEffect, useState } from 'react';
import { InputNumber, Space } from 'antd';

interface ProxyReadTimeoutInputProps {
    value?: string;
    onChange?: (value: string) => void;
}

const ProxyReadTimeoutInput: React.FC<ProxyReadTimeoutInputProps> = ({ value, onChange }) => {
    // 存储数字部分
    const [num, setNum] = useState<string>('');

    useEffect(() => {
        if (value) {
            // 假设 value 形如 "3秒" 或 "3"
            const matches = value.match(/(\d+)/);
            setNum(matches ? matches[1] : '');
        } else {
            setNum('');
        }
    }, [value]);

    const triggerChange = (newNum: string) => {
        if (onChange) {
            // 拼接固定单位 "秒"
            onChange(newNum);
        }
    };

    return (
        <Space align="baseline">
            <InputNumber
                value={num ? Number(num) : undefined}
                onChange={(val) => {
                    const newVal = val !== null ? String(val) : '';
                    setNum(newVal);
                    triggerChange(newVal);
                }}
            />
            <span>秒</span>
        </Space>
    );
};

export default ProxyReadTimeoutInput;
